import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { LandingTeaserComponent } from './landing-teaser/landing-teaser.component';

@Component({
    selector: 'ez-landing',
    template: require('./landing.component.html'),
    styles: [require('./landing.component.less')],
    encapsulation: ViewEncapsulation.None
})
export class LandingComponent implements OnInit {
    @ViewChild('template', {read: ViewContainerRef}) private template: ViewContainerRef;
    private componentReference: any;

    constructor(
        private resolver: ComponentFactoryResolver
    ) {}

    public ngOnInit(): void {
        let factory = this.resolver.resolveComponentFactory(LandingTeaserComponent);
        this.componentReference = this.template.createComponent(factory);
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/landing/landing.component.ts